import { socialType } from "../../../types/allTypes";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { socialAni } from "../../../utils/animation";
interface props {
  data: socialType;
  svgWidth: string;
  width: string;
  hasTransition: boolean;
  isSquare?: boolean;
}
const Social: React.FC<props> = ({
  data,
  svgWidth,
  width,
  hasTransition,
  isSquare,
}) => {
  const [isHovering, setIsHovering] = useState(false);
  return (
    <motion.li
      onHoverStart={() => setIsHovering(true)}
      onHoverEnd={() => setIsHovering(false)}
      onTouchStart={() => setIsHovering(true)}
      onTouchEnd={() => setIsHovering(false)}
      className={`group/social text-xl bg-white/5 border border-white/10 overflow-hidden flex justify-center items-center
        aspect-square will-change-transform ${
          hasTransition && "duration-500 delay-200"
        } ${isSquare ? "rounded-xl bg-primary-50/10" : "rounded-full"}`}
      style={{ width }}
    >
      <a
        className="w-full h-full flex justify-center items-center relative will-change-transform"
        href={data.href}
        target="_blank"
        rel="noreferrer"
        aria-label={data.href}
      >
        <AnimatePresence>
          {isHovering && (
            <motion.div
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={socialAni}
              style={{ width }}
              className={`absolute left-0 top-0 z-0 bg-white aspect-square will-change-transform ${isSquare ? "rounded-xl" : "rounded-full"}`}
            ></motion.div>
          )}
        </AnimatePresence>
        <span
          className={`z-10 will-change-transform fill-zinc-400 ${
            isHovering && "!fill-primary-45"
          } ${hasTransition && "duration-300 delay-75"}`}
          style={{ width: svgWidth }}
        >
          {data.icon}
        </span>
      </a>
    </motion.li>
  );
};

export default Social;
